export default __webpack_public_path__ + "../staticImages/p13n-banner.svg";